<template>
  <v-app>
    <v-main>
      <v-container
        fluid
        class="pa-0 fill-height gradient-bg"
      >
        <v-row
          no-gutters
          class="fill-height"
        >
          <!-- Lado Esquerdo: Branding -->
          <v-col
            cols="12"
            md="6"
            class="d-none d-md-flex bg-black align-center justify-center pa-16"
          >
            <div class="text-center">
              <img
                :src="require(`@/assets/DRmed-03.png`)"
                width="700"
                alt="DrMedPro"
              >
            </div>
          </v-col>

          <!-- Lado Direito: Formulário de Login -->
          <v-col
            cols="12"
            md="6"
            class="d-flex align-center justify-center pa-8"
          >
            <v-sheet
              rounded="xl"
              class="elevated-card pa-8"
              max-width="500"
              width="100%"
            >
              <div class="d-flex justify-center mb-6">
                <v-avatar
                  size="80"
                  color="primary"
                  class="elevation-3"
                >
                  <v-img
                    :src="require(`@/assets/drMedicPro_.png`)"
                  />
                </v-avatar>
              </div>

              <v-window v-model="step">
                <!-- Janela de Login -->
                <v-window-item :value="1">
                  <h2 class="text-h4 font-weight-bold text-center mb-2 custom-font">
                    Acesse sua conta
                  </h2>
                  <p class="text-center text-medium-emphasis mb-6">
                    Informe suas credenciais para continuar
                  </p>
          
                  <v-form
                    ref="loginForm"
                    class="mt-4"
                  >
                    <!-- Campo UF como Select -->
                    <v-select
                      v-model="user.uf"
                      prepend-inner-icon="location_on"
                      variant="outlined"
                      name="uf"
                      label="UF"
                      color="primary"
                      :items="ufs"
                      item-title="sigla"
                      item-value="sigla"
                      class="mb-4"
                      :rules="[v => !!v || 'UF é obrigatória']"
                      @keyup.enter="logar()"
                    />
                    
                    <!-- Campo CRM -->
                    <v-text-field
                      ref="searchLogin"
                      v-model="user.crm"
                      prepend-inner-icon="badge"
                      variant="outlined"
                      name="crm"
                      label="CRM"
                      type="text"
                      color="primary"
                      class="mb-4"
                      :rules="[v => !!v || 'CRM é obrigatório']"
                      @keyup.enter="logar()"
                    />
                    
                    <v-text-field
                      v-model="user.password"
                      variant="outlined"
                      name="password"
                      prepend-inner-icon="lock"
                      label="Senha"
                      :type="showPassword ? 'text' : 'password'"
                      color="primary"
                      :append-inner-icon="showPassword ? 'visibility_off' : 'visibility'"
                      @keyup.enter="logar()"
                      @click:append-inner="showPassword = !showPassword"
                    />
                    
                    <v-btn 
                      block 
                      size="large" 
                      color="primary" 
                      class="mt-4 rounded-pill" 
                      :loading="loading"
                      @click="logar()"
                    >
                      <span class="text-button">Entrar</span>
                    </v-btn>
                  </v-form>

                  <div class="text-center mt-4">
                    <v-btn
                      variant="text"
                      color="primary"
                      @click="step = 2; recoveryStep = 1;"
                    >
                      Esqueci minha senha
                    </v-btn>
                  </div>
                </v-window-item>

                <!-- Janela de Recuperação de Senha -->
                <v-window-item :value="2">
                  <h2 class="text-h4 font-weight-bold text-center mb-2 custom-font">
                    Recuperar Senha
                  </h2>
                  <p class="text-center text-medium-emphasis mb-6">
                    Siga os passos para redefinir sua senha
                  </p>

                  <div v-if="recoveryStep === 1">
                    <v-form ref="formCpf">
                      <v-text-field
                        v-model="cpf"
                        v-mask="'###.###.###-##'"
                        label="CPF"
                        prepend-inner-icon="article"
                        variant="outlined"
                        :rules="[v => !!v || 'CPF é obrigatório', v => v && v.length === 14 || 'CPF inválido']"
                        color="primary"
                        @keyup.enter="buscarCelular"
                      />
                    </v-form>

                    <v-row class="mt-4">
                      <v-col cols="6">
                        <v-btn
                          variant="outlined"
                          block
                          @click="step = 1"
                        >
                          Voltar
                        </v-btn>
                      </v-col>
                      <v-col cols="6">
                        <v-btn
                          color="primary"
                          block
                          :loading="loadingCelular"
                          @click="buscarCelular"
                        >
                          Continuar
                        </v-btn>
                      </v-col>
                    </v-row>
                  </div>

                  <div v-else-if="recoveryStep === 2">
                    <v-alert
                      type="info"
                      variant="tonal"
                      class="mb-4"
                    >
                      Informe os 4 últimos dígitos do número exibido para receber o código de verificação.
                    </v-alert>

                    <v-form ref="formCelular">
                      <v-text-field
                        v-model="celularMasked"
                        label="Celular"
                        prepend-inner-icon="smartphone"
                        variant="outlined"
                        disabled
                        color="primary"
                        class="mb-4"
                      />
                      
                      <v-text-field
                        v-model="celularFinal"
                        label="Confirme os últimos dígitos"
                        prepend-inner-icon="pin"
                        variant="outlined"
                        :rules="[v => !!v || 'Dígitos são obrigatórios', v => v === celularFinalCorreto || 'Dígitos incorretos']"
                        color="primary"
                        @keyup.enter="enviarCodigo"
                      />
                    </v-form>

                    <v-row class="mt-4">
                      <v-col cols="6">
                        <v-btn
                          variant="outlined"
                          block
                          @click="recoveryStep = 1"
                        >
                          Voltar
                        </v-btn>
                      </v-col>
                      <v-col cols="6">
                        <v-btn
                          color="primary"
                          block
                          :disabled="!celularFinal || celularFinal !== celularFinalCorreto"
                          :loading="loadingEnvio"
                          @click="enviarCodigo"
                        >
                          Enviar Código
                        </v-btn>
                      </v-col>
                    </v-row>
                  </div>

                  <div v-else-if="recoveryStep === 3">
                    <v-alert
                      v-if="codigoValidado"
                      type="success"
                      variant="tonal"
                      class="mb-4"
                    >
                      Código validado com sucesso! Agora defina sua nova senha.
                    </v-alert>

                    <v-alert
                      v-if="codigoExpiraEm > 0"
                      type="info"
                      variant="tonal"
                      class="mb-4"
                    >
                      O código expira em {{ Math.floor(codigoExpiraEm / 60) }}:{{ (codigoExpiraEm % 60).toString().padStart(2, '0') }}
                    </v-alert>

                    <v-form ref="formCodigo">
                      <v-text-field
                        v-model="codigo"
                        v-mask="'######'"
                        label="Código de Verificação"
                        prepend-inner-icon="vpn_key"
                        variant="outlined"
                        :rules="[v => !!v || 'Código é obrigatório']"
                        :disabled="codigoValidado"
                        color="primary"
                        class="mb-4"
                      />

                      <template v-if="codigoValidado">
                        <v-text-field
                          v-model="novaSenha"
                          label="Nova Senha"
                          prepend-inner-icon="lock"
                          variant="outlined"
                          :type="mostrarSenha ? 'text' : 'password'"
                          :append-inner-icon="mostrarSenha ? 'visibility_off' : 'visibility'"
                          color="primary"
                          class="mb-2"
                          @input="validarSenha"
                          @click:append-inner="mostrarSenha = !mostrarSenha"
                        />

                        <v-progress-linear
                          :value="forcaSenha * 25"
                          :color="forcaSenha < 2 ? 'red' : forcaSenha < 3 ? 'orange' : forcaSenha < 4 ? 'yellow' : 'green'"
                          height="6"
                          class="mb-4 rounded-pill"
                        />

                        <v-text-field
                          v-model="confirmarSenha"
                          label="Confirmar Nova Senha"
                          prepend-inner-icon="lock"
                          variant="outlined"
                          :type="mostrarSenha ? 'text' : 'password'"
                          :rules="[v => !!v || 'Confirmação é obrigatória', v => v === novaSenha || 'As senhas não coincidem']"
                          color="primary"
                          class="mb-4"
                        />
                        
                        <div class="senha-requirements mt-3">
                          <div
                            v-for="(req, index) in requisitosSenha"
                            :key="index"
                            class="d-flex align-center mb-1"
                          >
                            <v-icon
                              :color="req.valid ? 'success' : 'error'"
                              size="small"
                            >
                              {{ req.valid ? 'check_circle' : 'cancel' }}
                            </v-icon>
                            <span
                              class="ml-2 text-caption"
                              :class="{ 'text-success': req.valid, 'text-error': !req.valid }"
                            >
                              {{ req.text }}
                            </span>
                          </div>
                        </div>

                        <v-alert
                          v-if="todosRequisitosAtendidos"
                          type="success"
                          variant="tonal"
                          density="compact"
                          class="mt-2"
                        >
                          Senha forte criada com sucesso!
                        </v-alert>
                      </template>
                    </v-form>

                    <div class="text-center mt-2">
                      <v-btn
                        variant="text"
                        color="primary"
                        size="small"
                        :disabled="tempoReenvio > 0"
                        @click="enviarCodigo"
                      >
                        Reenviar código {{ tempoReenvio > 0 ? `(${tempoReenvio}s)` : '' }}
                      </v-btn>
                    </div>

                    <v-row class="mt-4">
                      <v-col cols="6">
                        <v-btn
                          variant="outlined"
                          block
                          @click="recoveryStep = 2"
                        >
                          Voltar
                        </v-btn>
                      </v-col>
                      <v-col cols="6">
                        <v-btn
                          v-if="!codigoValidado"
                          color="primary"
                          block
                          :loading="loadingValidacao"
                          @click="validarCodigo"
                        >
                          Validar Código
                        </v-btn>
                        <v-btn
                          v-else
                          color="success"
                          block
                          :loading="loadingRedefinicao"
                          :disabled="!todosRequisitosAtendidos || novaSenha !== confirmarSenha"
                          @click="redefinirSenha"
                        >
                          Redefinir Senha
                        </v-btn>
                      </v-col>
                    </v-row>
                  </div>
                </v-window-item>
              </v-window>
            </v-sheet>
          </v-col>
        </v-row>
      </v-container>

      <!-- Snackbar global para alertas -->
      <v-snackbar
        v-model="alert"
        :timeout="5000"
        :color="alertType"
        location="top right"
      >
        {{ msg }}
        <template #actions>
          <v-btn
            icon
            @click="alert = false"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </template>
      </v-snackbar>
    </v-main>
  </v-app>
</template>

<script>
import commonUserService from '../services/commonUser.service'
import usuarioService from '../services/usuario.service'
import { mask } from 'vue-the-mask'

var sha1 = require('sha1')

export default {
  name: 'LoginView',

  directives: {
    mask
  },
  data: () => ({
    // Login
    user: {
      uf: 'BA',
      crm: '',
      password: ''
    },
    loading: false,
    alert: false,
    alertType: 'error',
    msg: '',
    showPassword: false,
    loginTimeout: null,

    // Lista de UFs
    ufs: [
      { sigla: 'AC', nome: 'Acre' },
      { sigla: 'AL', nome: 'Alagoas' },
      { sigla: 'AP', nome: 'Amapá' },
      { sigla: 'AM', nome: 'Amazonas' },
      { sigla: 'BA', nome: 'Bahia' },
      { sigla: 'CE', nome: 'Ceará' },
      { sigla: 'DF', nome: 'Distrito Federal' },
      { sigla: 'ES', nome: 'Espírito Santo' },
      { sigla: 'GO', nome: 'Goiás' },
      { sigla: 'MA', nome: 'Maranhão' },
      { sigla: 'MT', nome: 'Mato Grosso' },
      { sigla: 'MS', nome: 'Mato Grosso do Sul' },
      { sigla: 'MG', nome: 'Minas Gerais' },
      { sigla: 'PA', nome: 'Pará' },
      { sigla: 'PB', nome: 'Paraíba' },
      { sigla: 'PR', nome: 'Paraná' },
      { sigla: 'PE', nome: 'Pernambuco' },
      { sigla: 'PI', nome: 'Piauí' },
      { sigla: 'RJ', nome: 'Rio de Janeiro' },
      { sigla: 'RN', nome: 'Rio Grande do Norte' },
      { sigla: 'RS', nome: 'Rio Grande do Sul' },
      { sigla: 'RO', nome: 'Rondônia' },
      { sigla: 'RR', nome: 'Roraima' },
      { sigla: 'SC', nome: 'Santa Catarina' },
      { sigla: 'SP', nome: 'São Paulo' },
      { sigla: 'SE', nome: 'Sergipe' },
      { sigla: 'TO', nome: 'Tocantins' }
    ],

    // Recuperação de senha
    step: 1, // 1 = login, 2 = recuperação
    recoveryStep: 1, // 1 = CPF, 2 = celular, 3 = código
    cpf: '',
    celular: '',
    celularMasked: '',
    celularFinal: '',
    celularFinalCorreto: '',
    celularCompleto: '',
    codigo: '',
    idUsuario: null,
    codigoValidado: false,
    novaSenha: '',
    confirmarSenha: '',
    mostrarSenha: false,
    codigoEnviadoPor: '', // 'sms' ou 'whatsapp'
    tempoReenvio: 0,
    timerReenvio: null,
    codigoExpiraEm: 0,
    codigoTimer: null,
    forcaSenha: 0,

    // Loadings
    loadingCelular: false,
    loadingEnvio: false,
    loadingValidacao: false,
    loadingRedefinicao: false,
    
    // Validação de senha
    requisitosSenha: [
      { text: 'Mínimo 8 caracteres', valid: false },
      { text: 'Pelo menos uma letra maiúscula', valid: false },
      { text: 'Pelo menos um número', valid: false },
      { text: 'Pelo menos um caractere especial', valid: false }
    ],
    todosRequisitosAtendidos: false
  }),

  mounted () {
    this.$nextTick(() => {
      if (this.$refs.searchLogin && this.$refs.searchLogin.focus) {
        this.$refs.searchLogin.focus()
      }
    })
  },

  beforeUnmount () {
    clearInterval(this.timerReenvio)
    clearInterval(this.codigoTimer)
    clearTimeout(this.loginTimeout)
  },

  methods: {
    validarSenha () {
      const senha = this.novaSenha

      // Valida cada requisito
      this.requisitosSenha[0].valid = senha && senha.length >= 8
      this.requisitosSenha[1].valid = /[A-Z]/.test(senha)
      this.requisitosSenha[2].valid = /[0-9]/.test(senha)
      this.requisitosSenha[3].valid = /[^A-Za-z0-9]/.test(senha)

      // Verifica se todos os requisitos foram atendidos
      this.todosRequisitosAtendidos = this.requisitosSenha.every(req => req.valid)

      // Atualiza força da senha
      this.forcaSenha = this.requisitosSenha.filter(req => req.valid).length
    },

    showAlert (message, type = 'error') {
      this.msg = message
      this.alertType = type
      this.alert = true
    },

    unmask (str) {
      return str ? str.replace(/[^\d]/g, '') : ''
    },

    async buscarCelular () {
      if (this.$refs.formCpf && !this.$refs.formCpf.validate()) return

      this.loadingCelular = true
      try {
        const cpfUnmasked = this.unmask(this.cpf)
        const respCpf = await commonUserService.usuario.buscarIdPorCPF(cpfUnmasked)

        if (respCpf.status == 200 && respCpf.data.usuario && respCpf.data.usuario !== 'false') {
          this.idUsuario = respCpf.data.usuario.id

          const response = await usuarioService.buscarTelefonePorCPF(cpfUnmasked)

          if (response.data.status === 'ok' && response.data.celular) {
            this.celular = response.data.celular
            this.celularMasked = `(${response.data.celular.substring(0, 2)}) ${response.data.celular.substring(2, 7)}-XXXX`
            this.celularFinalCorreto = response.data.celular.substring(7)
            this.celularCompleto = `(${response.data.celular.substring(0, 2)}) ${response.data.celular.substring(2, 7)}-${response.data.celular.substring(7)}`
            this.recoveryStep = 2
          } else {
            this.showAlert('CPF não encontrado ou sem celular cadastrado')
          }
        } else {
          this.showAlert('CPF não encontrado')
        }
      } catch (error) {
        this.showAlert((error.response && error.response.data && error.response.data.message) || error.message || 'CPF não encontrado ou sem celular cadastrado')
      } finally {
        this.loadingCelular = false
      }
    },

    async enviarCodigo () {
      if (this.recoveryStep === 2 && this.$refs.formCelular && (!this.$refs.formCelular.validate() || this.celularFinal !== this.celularFinalCorreto)) {
        this.showAlert('Dígitos incorretos')
        return
      }

      this.loadingEnvio = true
      try {
        const response = await usuarioService.validarWatsApp(this.unmask(this.celular))
        if (response.data.status === 'Recebido') {
          this.codigoEnviadoPor = 'whatsapp'
          this.recoveryStep = 3
          this.codigo = ''
          this.iniciarTemporizadorReenvio()
          this.iniciarTemporizadorCodigo()
          this.showAlert('Código enviado com sucesso!', 'success')
        }
      } catch (error) {
        this.showAlert((error.response && error.response.data && error.response.data.message) || 'Falha ao enviar código por SMS')
      } finally {
        this.loadingEnvio = false
      }
    },

    iniciarTemporizadorReenvio () {
      this.tempoReenvio = 30
      clearInterval(this.timerReenvio)
      this.timerReenvio = setInterval(() => {
        if (this.tempoReenvio > 0) {
          this.tempoReenvio--
        } else {
          clearInterval(this.timerReenvio)
        }
      }, 1000)
    },

    iniciarTemporizadorCodigo () {
      this.codigoExpiraEm = 300 // 5 minutos em segundos
      clearInterval(this.codigoTimer)
      this.codigoTimer = setInterval(() => {
        if (this.codigoExpiraEm > 0) {
          this.codigoExpiraEm--
        } else {
          clearInterval(this.codigoTimer)
          this.showAlert('O código expirou. Por favor, solicite um novo.')
        }
      }, 1000)
    },

    async validarCodigo () {
      if (!this.codigo || this.codigo.length !== 6) {
        this.showAlert('Por favor, insira um código válido de 6 dígitos')
        return
      }

      this.loadingValidacao = true
      try {
        const response = await usuarioService.validarCodigo(this.codigo, this.unmask(this.celular))

        if (response.data.status === 'ok') {
          this.codigoValidado = true
          this.showAlert('Código validado com sucesso! Agora você pode definir uma nova senha.', 'success')
        } else {
          throw new Error('Código inválido')
        }
      } catch (error) {
        this.showAlert((error && error.response && error.response.data && error.response.data.message) ||
                   error.message ||
                   'Código inválido ou expirado')
      } finally {
        this.loadingValidacao = false
      }
    },

    async redefinirSenha () {
      if (this.novaSenha !== this.confirmarSenha) {
        this.showAlert('As senhas não coincidem')
        return
      }

      if (!this.todosRequisitosAtendidos) {
        this.showAlert('A senha não atende a todos os requisitos de segurança')
        return
      }

      this.loadingRedefinicao = true
      try {
        const response = await commonUserService.usuario.redefinirSenha({
          id: this.idUsuario,
          password: sha1(this.novaSenha)
        })

        if (response.status === 200) {
          this.showAlert('Senha redefinida com sucesso!', 'success')

          setTimeout(() => {
            this.step = 1
            this.resetRecuperacao()
          }, 2000)
        } else {
          throw new Error('Falha ao redefinir senha')
        }
      } catch (error) {
        this.showAlert((error && error.response && error.response.data && error.response.data.message) ||
                   error.message ||
                   'Falha ao redefinir senha')
      } finally {
        this.loadingRedefinicao = false
      }
    },

    resetRecuperacao () {
      this.recoveryStep = 1
      this.cpf = ''
      this.celular = ''
      this.celularMasked = ''
      this.celularFinal = ''
      this.celularFinalCorreto = ''
      this.celularCompleto = ''
      this.codigo = ''
      this.novaSenha = ''
      this.confirmarSenha = ''
      this.codigoEnviadoPor = ''
      this.codigoValidado = false
      this.forcaSenha = 0
      this.todosRequisitosAtendidos = false
      this.requisitosSenha.forEach(req => req.valid = false)
      clearInterval(this.timerReenvio)
      clearInterval(this.codigoTimer)
      this.tempoReenvio = 0
      this.codigoExpiraEm = 0
    },

    async logar () {
      this.loading = true
      this.alert = false

      if (this.loginTimeout) {
        clearTimeout(this.loginTimeout)
      }

      this.loginTimeout = setTimeout(() => {
        this.loading = false
        this.showAlert('Tempo excedido - servidor não respondeu')
      }, 15000)

      if (this.user.uf && this.user.crm && this.user.password) {
        try {
          this.$store.dispatch('updateProntuario', [{ idAtendimento: '', conteudoLaudo: '', conteudoProntuario: '' }])
          
          // Buscar médico por UF e CRM
          
            const loginData = {
              uf: this.user.uf,
              crm: this.user.crm,
              password: this.user.password
            }
            
            console.log('Tentando login com:', loginData)
            
            this.$store.dispatch('Login', loginData)
              .then(r => {
                console.log('Login bem-sucedido:', r)
                clearTimeout(this.loginTimeout)
                this.loading = false

                if (r.perfil && r.perfil === 'nutricionista') {
                  return this.$router.push('/homeNutricionista')
                }

                const perfilNormalizado = (r.perfil || '').toString().toLowerCase()
                const tipoUsuario = Number(r.tipo)
                if (perfilNormalizado === 'medico' || [4, 8].includes(tipoUsuario)) {
                  return this.$router.push('/homeMedico')
                }

                const redirectMap = {
                  1: '/dashboardEmpresa',
                  2: '/homeRecepcionista',
                  3: '/homeAtendente',
                  4: '/homeMedico',
                  5: '/dashboardUnidade',
                  6: () => {
                    this.$store.dispatch('SetLoginPainel', loginData.username)
                    this.$store.dispatch('SetSenhaPainel', loginData.password)
                    return '/HomePainel'
                  },
                  7: '/homeApoio',
                  8: '/homeMedico',
                  10: '/homeAdministradorDev',
                  11: '/homeRecepcionistaEspecial',
                  12: '/posAtendimento',
                  13: '/homeNutricionista'
                }

                const redirectTo = redirectMap[r.tipo]
                if (typeof redirectTo === 'function') {
                  this.$router.push(redirectTo())
                } else if (redirectTo) {
                  this.$router.push(redirectTo)
                } else {
                  this.showAlert('Tipo de usuário não reconhecido')
                }
              })
              .catch(error => {
                clearTimeout(this.loginTimeout)
                this.loading = false
                this.showAlert(error.message || error || 'Erro desconhecido ao fazer login')
              })
          
        } catch (error) {
          clearTimeout(this.loginTimeout)
          this.loading = false
          this.showAlert(error.message || 'Erro ao buscar dados do médico')
        }
      } else {
        clearTimeout(this.loginTimeout)
        this.loading = false
        this.showAlert('Por favor, preencha todos os campos')
      }
    }
  }
}
</script>

<style scoped>
.gradient-bg {
  background: linear-gradient(135deg, #83C6A3 0%, #83C6A3 100%);
}

.custom-bg {
  background-color: #99CC99;
}

.left-side {
  background-color: #0d1a2e;
  color: #ffffff;
}

.logo-container {
  text-align: center;
}

.responsive-logo {
  max-width: 100%;
  height: auto;
  max-height: 150px;
}

.right-side {
  background-color: #ffffff;
}

.login-card {
  width: 100%;
  max-width: 400px;
}

.v-card__actions {
  padding: 8px 0;
}

.v-alert {
  border-radius: 12px !important;
}

.senha-requirements {
  font-size: 0.8rem;
}

.elevated-card {
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1) !important;
  border-radius: 16px;
}
</style>
